import ReactGA from "react-ga4";

export const GA_MEASUREMENT_ID = "G-PEJ3FTVL5K";

let isInitialized = false;

export const hasConsent = () => {
    return localStorage.getItem('cookie_consent') === 'accepted';
};

export const initGA = () => {
    if (isInitialized) return;
    if (hasConsent()) {
        ReactGA.initialize(GA_MEASUREMENT_ID);
        isInitialized = true;
    }
};

export const trackPageView = (path) => {
    if (!isInitialized && hasConsent()) {
        initGA();
    }
    if (isInitialized) {
        ReactGA.send({
            hitType: "pageview",
            page: path,
        });
    }
};

export const trackEvent = ({ category, action, label, value, nonInteraction }) => {
    if (!isInitialized && hasConsent()) {
        initGA();
    }
    if (isInitialized) {
        ReactGA.event({
            category,
            action,
            label,
            value,
            nonInteraction,
        });
    }
};